import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import { useMemo } from 'react';
import CommonTitle from '../CommonTitle';
import { AnimatedGrid } from '../AnimatedSection';
import styled from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

interface ImgsType {
    [locale: string]: string[];
}

const IMGS_MAP: ImgsType = {
    us: [
        'https://websiteoss.ecoflow.com/figma-uploads/1757759237221-ztkpk8-compressed-Output.png',
        'https://websiteoss.ecoflow.com/figma-uploads/1757759251485-uvj0tp-compressed-Solar%20Generation.png',
        'https://websiteoss.ecoflow.com/figma-uploads/1758854946222-9e58mu-compressed-Earning.png',
    ],
    ca: [
        'https://websiteoss.ecoflow.com/figma-uploads/1757759237221-ztkpk8-compressed-Output.png',
        'https://websiteoss.ecoflow.com/figma-uploads/1757759251485-uvj0tp-compressed-Solar%20Generation.png',
        'https://websiteoss.ecoflow.com/figma-uploads/1758854946222-9e58mu-compressed-Earning.png',
    ],
};

const DEFAULT_LOCALE = 'us';

const SectionPhone: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('SectionPhone');

    const imgs = useMemo(() => {
        return IMGS_MAP[locale] || IMGS_MAP[DEFAULT_LOCALE];
    }, [locale]);

    const items = useMemo(
        () => [
            { img: imgs[0], text: t('tip1') },
            { img: imgs[1], text: t('tip2') },
            { img: imgs[2], text: t('tip3') },
        ],
        [imgs, t],
    );

    return (
        <div className={`${styled.SectionPhone} range6 GtmModuleData-section`} data-section-id="d3c-SectionPhone" id="SectionPhone">
            <EcoSpace />
            <CommonTitle title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <AnimatedGrid variant="rotateIn" options={{ delay: 400, stagger: 0.15, threshold: 0.2 }} className="content">
                {items.map((item, index) => (
                    <div key={index} className="item">
                        <EcoImg isOpenLazy={true} pc={item.img} alt={item.text} />
                        <div className="text">{item.text}</div>
                    </div>
                ))}
            </AnimatedGrid>
            <EcoSpace />
        </div>
    );
};

export default SectionPhone;
